// extracted by mini-css-extract-plugin
export default {"container":"pdfReader_container__M0GJK","header":"pdfReader_header__rLzQn","pdfContainer":"pdfReader_pdfContainer__YIEJT","ducumentPage":"pdfReader_ducumentPage__K6GVu"};